import React, { useState } from 'react'
import { tokens } from '../../styles/desertFloraTheme'

const fmt = (v) => '$' + (v || 0).toLocaleString('en-US', { minimumFractionDigits: 0 })

const ScenarioTabs = ({ scenarios, activeId, onChange, onSnapshot, projectTotals }) => {
  const [naming, setNaming] = useState(false)
  const [newName, setNewName] = useState('')

  const allTabs = [
    { id: '__base', name: 'Base', total: projectTotals?.sell || 0 },
    ...(scenarios || [])
  ]

  const handleAdd = () => {
    if (!naming) {
      setNaming(true)
      setNewName('')
      return
    }
    const name = newName.trim()
    if (!name) { setNaming(false); return }
    onSnapshot(name)
    setNaming(false)
    setNewName('')
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleAdd()
    if (e.key === 'Escape') setNaming(false)
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <div style={{
        display: 'inline-flex',
        background: tokens.bg2,
        borderRadius: 999,
        padding: 3,
        border: '1px solid ' + tokens.line
      }}>
        {allTabs.map(tab => {
          const isActive = tab.id === activeId || (tab.id === '__base' && !activeId)
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id === '__base' ? null : tab.id)}
              style={{
                padding: '4px 12px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
                background: isActive ? tokens.surface : 'transparent',
                color: isActive ? tokens.ink : tokens.ink3,
                boxShadow: isActive ? '0 1px 2px rgba(28,36,25,.06)' : 'none',
                border: 'none',
                outline: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                transition: 'background .12s'
              }}
            >
              {tab.name}
              <span style={{
                fontFamily: tokens.fontMono,
                fontSize: 10,
                color: isActive ? tokens.ink3 : tokens.ink4,
                fontWeight: 500
              }}>
                {fmt(tab.total)}
              </span>
            </button>
          )
        })}
      </div>

      {naming ? (
        <input
          autoFocus
          type="text"
          placeholder="Scenario name..."
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleAdd}
          style={{
            fontFamily: tokens.fontUi,
            fontSize: 12,
            background: tokens.surface,
            border: '1px solid ' + tokens.line,
            borderRadius: 999,
            padding: '4px 10px',
            width: 120,
            outline: 'none',
            color: tokens.ink
          }}
        />
      ) : (
        <button
          type="button"
          onClick={handleAdd}
          style={{
            background: 'none',
            border: '1px dashed ' + tokens.line2,
            borderRadius: 999,
            width: 26,
            height: 26,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: tokens.ink3,
            fontSize: 16,
            fontWeight: 300,
            lineHeight: 1,
            transition: 'background .12s'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.background = tokens.bg2 }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'none' }}
          title="Save scenario snapshot"
        >
          +
        </button>
      )}
    </div>
  )
}

export default ScenarioTabs
